import React from "react";
import { Box, Button, IconButton, TextField, Typography } from "@mui/material";
import { Add as AddIcon } from "../icons";
import { DeleteOutline as DeleteOutlineIcon } from "../icons";
import DatePicker from "react-date-picker";
import "react-date-picker/dist/DatePicker.css";
import { T } from "../routes/Translate";

// Una o varias fechas para un evento (ej. funciones de una obra o varias
// noches de un recital). Cada fila tiene día + hora opcional; ver
// rowsToEventDates / eventDatesToRows en eventsUtils.js.
const EventDatesField = ({ value, onChange, error }) => {
  const rows = value?.length ? value : [{ day: null, time: "" }];
  const update = (index, patch) => onChange(rows.map((row, i) => (i === index ? { ...row, ...patch } : row)));
  const remove = (index) => onChange(rows.filter((_, i) => i !== index));
  const add = () => {
    // La nueva fila arranca con la misma hora que la última, que suele repetirse.
    const last = rows[rows.length - 1];
    onChange([...rows, { day: null, time: last?.time || "" }]);
  };

  return (
    <Box mt={2} mb={1}>
      <Typography>
        {rows.length > 1 ? <T>Fechas del evento:</T> : <T>Fecha del evento:</T>}
      </Typography>
      {rows.map((row, index) => (
        <Box key={index} sx={{ display: "flex", alignItems: "center", gap: 1, mt: 1, flexWrap: "wrap" }}>
          <DatePicker onChange={(day) => update(index, { day })} value={row.day} format="dd/MM/yyyy" />
          <TextField
            type="time"
            size="small"
            label={<T>Hora (opcional)</T>}
            value={row.time}
            onChange={(e) => update(index, { time: e.target.value })}
            InputLabelProps={{ shrink: true }}
            sx={{ width: 150 }}
          />
          {rows.length > 1 && (
            <IconButton aria-label="Quitar fecha" onClick={() => remove(index)} size="small">
              <DeleteOutlineIcon fontSize="small" />
            </IconButton>
          )}
        </Box>
      ))}
      <Button size="small" startIcon={<AddIcon />} onClick={add} sx={{ mt: 1, textTransform: "none" }}>
        <T>Agregar otra fecha</T>
      </Button>
      {error && (
        <Typography sx={{ color: "error.main", fontSize: "0.75rem", mt: 0.5 }}>{error}</Typography>
      )}
    </Box>
  );
};

export default EventDatesField;
